module.exports = __webpack_public_path__ + "img/300706_888576_822821_876E79-256px.71f52671.png";